import request from '../../utils/request';

const fetchCampaigns = async (options = {}) => request('campaign', { ...options });
const fetchCampaign = async (id, options = {}) => request(`campaign/${id}`, { ...options });

export {
  fetchCampaign,
  fetchCampaigns,
}